import { render, staticRenderFns } from "./dialogFrom.vue?vue&type=template&id=3d496d20&scoped=true&"
import script from "./dialogFrom.vue?vue&type=script&lang=js&"
export * from "./dialogFrom.vue?vue&type=script&lang=js&"
import style0 from "./dialogFrom.vue?vue&type=style&index=0&id=3d496d20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d496d20",
  null
  
)

export default component.exports